export const sanitizeEventAttributes = (constructs) => {

    const handlers = constructs.handlers;

    const events = constructs.events.map(event => {

        event.attributes.onsend = handlers.find(handler => handler.event === event.id && handler.type === 'onsend') ? true : false;
        event.attributes.onrecv = handlers.find(handler => handler.event === event.id && handler.type === 'onrecv') ? true : false;

        return event;
    })

    constructs.events = events;

    return constructs;

}


export const getTransactionEvents = ({ transaction, handlers, events }) => {

    if (transaction == null)
        return [];

    let eventInfo = []
    const transactionEvents = events
        .sort(function (a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        });

    transactionEvents.forEach(item => {
        let onrecvHandler = {}
        let onsendHandler = {}
        if (item.attributes.onrecv) {
            const onrecv = handlers.find(handler => handler.type === 'onrecv' && handler.event === item._id)
            if (onrecv) onrecvHandler = onrecv
        }
        if (item.attributes.onsend) {
            const onsend = handlers.find(handler => handler.type === 'onsend' && handler.event === item._id)
            if (onsend) onsendHandler = onsend
        }
        eventInfo.push({ transaction: transaction, event: item, handlers: { onrecvHandler, onsendHandler } })
    });

    return eventInfo;
}


export const getEventParentTransaction = ({transactions, eventId}) => {
    for (const obj of transactions) {
        if (obj.events.some(event => event.id == eventId)) {
          return obj;
        }
    }
    return null;
}